import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  BlockAffinityResult,
  CreateAffinityBlacklistPayload
} from "../../recommendation.types";

export const requestBlockAffinityPairing = async (
  payload: CreateAffinityBlacklistPayload
): Promise<BlockAffinityResult> => {
  return await instance.post(
    ApiRoutesRecommendation.AffinityBlacklist,
    payload
  );
};
